export const DefaultUserInformationWrapper = ({ children, }) => children;
//# sourceMappingURL=DefaultUserInformationWrapper.js.map